// ============================================================================
// SUFFIX ARRAY - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'suffix-array',
  name: 'Suffix Array',
  category: 'Strings',
  complexity: {
    time: 'O(N log N)',
    space: 'O(N)'
  },
  description: 'A sorted array of all suffixes of a string. It enables efficient string operations like pattern matching, longest common substring, and longest repeated substring through binary search.'
};
